module.exports = __webpack_public_path__ + "static/img/accesos.9fb8813c.jpg";